import { compose, defaultProps, withHooks } from "enhancers";
import { Button } from "components";
import { DatePicker as FormikMuiDatePicker } from "formik-material-ui-pickers";
import { format } from "date-fns";

import { ReactComponent as DatePickerIcon } from "assets/icon/datepicker_icon.svg";
import T from "./T";
import { replaceNameSpace } from "utils/helper";
import { MaterialIcon } from "./MaterialIcon";
import { Box, styled } from "@material-ui/core";

const IconClickStyle = styled(MaterialIcon)({
  cursor: "pointer",
  opacity: 0.5,
  "&:hover": {
    opacity: 1,
  },
});

const DatePickerContainer = styled(Box)({
  position: "relative",
  "& .clear-icon": {
    opacity: 0,
    transition: "opacity 0.2s ease-in-out",
  },
  "&:hover .clear-icon": {
    opacity: 1,
  },
});

const DatePicker = ({ handleClear, ...props }: any) => (
  <DatePickerContainer>
    <FormikMuiDatePicker {...props} />
    {props.field.value && props.clearable && (
      <Box position="absolute" top={16} right={40} className="clear-icon">
        <IconClickStyle
          onClick={handleClear}
          name="CloseOutlined"
          fontSize="small"
        />
      </Box>
    )}
    <Box position="absolute" top={16} right={12}>
      <DatePickerIcon />
    </Box>
  </DatePickerContainer>
);

const enhancer = compose(
  defaultProps({ format: "dd/MM/yyyy" }),
  withHooks((props: any, hooks: any) => {
    const { useMemo } = hooks;
    const FormHelperTextProps = useMemo(
      () => ({
        component: (props: any) => (
          <T className={props.className}>
            {replaceNameSpace("yup.error", props.children)}
          </T>
        ),
      }),
      []
    );

    const handleClear = () => {
      props.form.setFieldValue(props.field.name, null);
    };

    return {
      ...props,
      handleClear,
      labelFunc: (date: Date, invalidLabel: string) =>
        props.field.value ? format(date, props.format) : "",
      FormHelperTextProps,
    };
  })
);

export default enhancer(DatePicker);
